import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ListConstants from './ListConstants';
import ConstantForm from '../../../common/ConstantForm';
import { drapcodeIcon } from '../../../../common/custom/icon-library';
import DocsLink from '../../../../common/custom/DocsLink';
import ParentDocCard from '../../../common/ParentDocCard';
import { isProjectReadOnly } from '../../../../common/utils/api_utils';
export default class CustomConstants extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    commonActions: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
    constants: PropTypes.array.isRequired,
    collection: PropTypes.object.isRequired,
  };

  handleSubmit = (values) => {
    const { projectId, collection, version, actions, commonActions } = this.props;
    actions.createCollectionConstant({
      projectId,
      version,
      collectionUuid: collection.uuid,
      data: values,
    });
    commonActions.trackCollectionChange({ uuid: collection.uuid, name: collection.collectionName });
  };

  showPublishedMessage = () => {
    const { updatedCollections, collection } = this.props;
    const { uuid } = collection;
    if (updatedCollections && updatedCollections.includes(uuid)) {
      return <span className="fw-lighter unpublished-tag text-warning">(Not Published)</span>;
    }
    return '';
  };

  render() {
    const {
      constants,
      projectId,
      version,
      collection,
      actions,
      commonActions,
      showDerivedConstantLoader,
      showConstantDeleteLoader,
      deleteFlag,
    } = this.props;
    const isReadOnly = isProjectReadOnly(projectId);
    return (
      <div className="row mx-auto">
        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
          <div className="col-md-12 col-lg-12 text-right"></div>
          <div className="row mx-auto">
            <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
              <div className="card">
                <div
                  className="card-header card-header-icon"
                  data-background-color="drapcode-dark-blue"
                >
                  <i className={`wb ${drapcodeIcon('form')}`}></i>
                </div>
                <div className="card-content">
                  <h5 className="card-title mb-0 pb-0">
                    Add Constant{' '}
                    {typeof collection !== 'undefined' && collection
                      ? ' To ' + collection.collectionTitle
                      : ''}
                    {this.showPublishedMessage()}
                  </h5>

                  <p className="mx-4 px-5">
                    Allows you to apply a constant or fixed value to filter the data entries.
                  </p>
                  <ConstantForm
                    constantType=""
                    handleSubmit={this.handleSubmit}
                    showDerivedConstantLoader={showDerivedConstantLoader}
                    isCollection={false}
                    isReadOnly={isReadOnly}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
              <div className="card">
                <div
                  className="card-header card-header-icon"
                  data-background-color="drapcode-dark-blue"
                >
                  <i className={`wb ${drapcodeIcon('list')}`}></i>
                </div>
                <div className="card-content">
                  <h5 className="card-title">Constants</h5>
                  <ListConstants
                    constants={constants}
                    projectId={projectId}
                    collection={collection}
                    version={version}
                    actions={actions}
                    commonActions={commonActions}
                    showDerivedConstantLoader={showDerivedConstantLoader}
                    showConstantDeleteLoader={showConstantDeleteLoader}
                    deleteFlag={deleteFlag}
                    isReadOnly={isReadOnly}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <ParentDocCard>
          <h5>
            <b>About Constants Field</b>
          </h5>
          <p>
            Allows you to apply a constant or fixed value to filter the data entries. Remember,
            once, a constant is created, it is added to a filter condition.
          </p>
          <br />
          <DocsLink link="https://academy.drapcode.com/docs/app-collection/constants-in-collection" />
        </ParentDocCard>
      </div>
    );
  }
}
